import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import eyeIcon from "../../../../Assets/icons/eye 1.svg";
import editIcon from "../../../../Assets/icons/Un-Checkbox.svg";
import downloadIcon from "../../../../Assets/icons/download.svg";

import {
  // TABLE_DATA,
  // TABLE_HEADERS,
  // keyMapping,
  topDataList,
} from "../../../../constants/SalesQuotationsList";

import ListPage from "../Shared/ListPage";
import ROUTES_NAVIGATION from "../../../../routes/routes";
import axiosInstance from "../../../services/api/API";
import SalesListPage from "../SalesComponents/SalesListPage";
import * as base64 from "base-64";
import Loader from "../../../customComponents/CustomLoader";

const InvoiceList = () => {

  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState('');
  const [leadAllocation,setLeadAllocation] = useState([])
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(true);

  const [validationErrors, setValidationErrors] = useState({});


  const token = localStorage.getItem("authToken");
  const [filters, setFilters] = useState({});
  const [filterFormData, setFilterFormData] = useState({});

  const handleOnAddQuotation = () => {
    navigate(ROUTES_NAVIGATION.ADDQUOTATION);
  };

  const handleEdit = (rowData) => {
    console.log(rowData, "rowData")
    navigate(`${ROUTES_NAVIGATION.EDITQUOTATION}`, { state: { data: rowData } });
  }

  const handleQuotationDetails = () => {
    navigate(ROUTES_NAVIGATION.VIEWQUOTATIONLIST)
  }

  useEffect(()=>{
    fethCustomerList()
  },[])

  const fethCustomerList = async (  page = 0, pageSize = 10) => {

    const allfilteredData=filters;
  
    try {
      setLoading(true)
      const response = await axiosInstance.post('/proposalinvoice/list', {
        // Adjust the API endpoint and parameters according to your API
        business_partner_id:1,
        orderBy: 'invoice_id desc',
        page,
        pageSize,
        fromDate:filterFormData.fromDate || '', //2024-05-01 date fomat
        toDate:filterFormData.toDate || "",
      searchText:searchQuery || ""
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });
  
      const formattedData = response.data.data.data.map((item, index) => ({
        ...item,
        "Sr No.": index + 1 ,
        fullamountrecived: item.fullamountrecived === 0 ? "Pending" : "Paid" 
      }));
  
      const totalRecordsData = response?.data?.data?.totalRecords
        console.log(totalRecordsData, "RECORDS")
        setTotalRecords(totalRecordsData);
  
      setLeadAllocation(formattedData);
     // toastSuccess("Product Data fetched successfully!");
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize)); 
    } catch (error) {
      console.error('Error fetching lead priorities:', error);
    } finally{
      setLoading(false)
    }
  };

  const keyMapping = {
    "Transaction Code": "transaction_code",
    "Customer Name": "customer_name",
    // "Transaction Code":"transaction_code",
    "Contact No.": "mobile_no",
    "Visit Date & Time": "created_at",
    // Location: "location_name",
    "Product": "product_name",
    "Sub-Product":"subproduct_name",
    "Make": "make_name",
    "Model": "model_name",
    "Variant":"variant_name",
    "Balance Amount":"balanceamount",
    "Paid Amount":"paymentamount",
    "Payment Status":"fullamountrecived",
    Action: [
      // { type: "edit", icon: editIcon, label: "Edit" },
      { type: "view", icon: eyeIcon, label: "View" },
      {
        type: "downloadinvoice",
        icon: downloadIcon,
        label: "download Icon",
      },
    ],
  };

  const TABLE_HEADERS = [
    "Transaction Code",
    "Customer Name",
    // "Contact No.",
    "Product",
    "Sub-Product",
    "Make",
    "Model",
    "Variant",
    "Balance Amount",
    "Paid Amount",
    "Payment Status",
    "Action",
  ];

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fethCustomerList(newPage);
  };

  const handleViewDetails = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.VIEWINVOICE}`, { state: { data: rowData } });
  }


  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      apiCallFunction(0, 10,searchQuery); 
    }
  }  
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const apiCallFunction = () =>{
    fethCustomerList()
  }


  const clearFilter = () => {
    setFilterFormData({});
    fethCustomerList();
  };

  const handleSearch=()=>{
fethCustomerList() 
  }

  const filtersInputs = [
    {
      name: "fromDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),
      required: false,
      gridClass: "col-lg-5",
  },
    {
        name: "toDate",
        label: "To Date",
        type: "date",
        maxDate: new Date(),
        required: false,
        gridClass: "col-lg-5",
    }
   
  ]

  // const handleQuotationApprovalDetails = () => {
  //   navigate(ROUTES_NAVIGATION.VIEWQUOTATIONAPPROVAL)
  // }

  const handleDownloadInvoice = (rowData) => {
    console.log(rowData, "rowDataquotId")
    var text = rowData?.invoice_id;
    var encoded = base64.encode(text);
    const pdfURL = `http://127.0.0.1:8599/api/v1/invoicepdfreport/invoiceDownload/${encoded}`;
    window.open(pdfURL, "_blank", "noopener,noreferrer");
  };



  return (
   
    <div>
    {loading ? ( 
      <Loader />
    ) : (
      <div>
        <SalesListPage
            isUploadButtonRequired={false}
            isAddButtonRequired={false}
            headerTopText="Sales / Invoice"
            headerTitle="Invoice"
            addButtonTitle="Add Quotation"
            listTitle="All Invoice"
            topDetailsList={topDataList}
            tableData={leadAllocation}
            tableHeaders={TABLE_HEADERS}
            keyMapping={keyMapping}
            handleOnAddButton={handleOnAddQuotation}
            handleViewButton={handleViewDetails}
            totalRecords={totalRecords} 
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange} 
      
            apiCallFunction={apiCallFunction}
            handleSearchChange={handleSearchChange}
            handleKeyPress={handleKeyPress}
            searchplaceholder="Search by Invoice Name"
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            onEdit={handleEdit}
      
      
            isFilterRequired= {true}
      
            handleFormSubmit={handleSearch}
                  filterFormData={filterFormData}
                  setFilterFormData={setFilterFormData}
                  filterInputs={filtersInputs}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors}
                  handleClear={clearFilter}
      
            handleDownloadButton={handleDownloadInvoice}
          />
   </div>
    )}
    </div>
  );
};

export default InvoiceList;
